import React from 'react';
import { Redirect } from 'react-router-dom';
import withSizes from 'react-sizes'
import update from 'immutability-helper';

import { AlertsService } from '../../services';

import AlertDetail from './alert_detail';

@withSizes(({ width }) => ({ isMobile: width < 600 }))
class MonitoringAlertDetail extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      eventId: props.match.params.eventId,
      errorMessage: null
    };
  }

  componentDidMount() {
    AlertsService.get(this.state.eventId, true).then((response) => {
      this.setState({ alert: response.alert });
    }).catch((error) => {
      this.setState({ errorMessage: 'Could not load alert for viewing.' });
      console.error(error);
    });
  }

  addResponse(response) {
    const existingAlert = this.state.alert;
    this.setState({ alert: null }, () => {
      AlertsService.addResponse(existingAlert.id, response).then(data => {
        this.setState({ 
          alert: update(existingAlert, { responses: {$push: [data.alertResponse]} })
        }, () => {
          if (this.handleLocalSuccess) {
            this.handleLocalSuccess('Event updated.');
          }
        });
      }).catch((error) => {
        console.log(error);

        this.setState({ alert: existingAlert });

        if (this.handleLocalError) {
          this.handleLocalError('Error event update.');
        }
      });
    });
  }

  updateStatus(newStatus) {
    const existingAlert = this.state.alert;
    this.setState({ alert: null }, () => {
      AlertsService.updateStatus(existingAlert.id, newStatus).then(_ => {
        this.setState({ 
          alert: update(existingAlert, { alertStatus: {$set: newStatus} })
        });

        if (this.handleLocalSuccess) {
          this.handleLocalSuccess('Event status saved.');
        }
      }).catch((error) => {
        this.setState({ alert: existingAlert });
        if (this.handleLocalError) {
          this.refs.handleLocalError('Error event status update.');
        }
        console.error(error);
      });
    });
  }

  updateNote(newNote) {
    const existingAlert = this.state.alert;
    this.setState({ alert: null }, () => {
      AlertsService.updateNote(existingAlert.id, newNote).then(_ => {
        this.setState({ 
          alert: update(existingAlert, { alertNotes: {$set: newNote} })
        });

        if (this.handleLocalSuccess) {
          this.handleLocalSuccess('Alert note saved.');
        }
      }).catch((error) => {
        this.setState({ alert: existingAlert });
        if (this.handleLocalError) {
          this.refs.handleLocalError('Error alert note update.');
        }
        console.error(error);
      });
    });
  }

  render() {
    if (this.state.errorMessage) {
      // TODO this should go back to the locations it came from
      return (<Redirect to={{ pathname: '/', state: { errorMessage: this.state.errorMessage } }} />);
    }

    if (this.state.alert) {
      return (
            <AlertDetail
                isMobile={this.props.isMobile}
                alert={this.state.alert}
                updateNote={this.updateNote.bind(this)}
                updateStatus={this.updateStatus.bind(this)}
                addResponse={this.addResponse.bind(this)}
                setHandleSuccess={handleLocalSuccess => this.handleLocalSuccess = handleLocalSuccess}
                setHandleError={handleLocalError => this.handleLocalError = handleLocalError}
                ref="alertDetails"
            />
        );
    } else {
      return (
          <div className="loader">Loading...</div>
      );
    }
  }

}

export default MonitoringAlertDetail;
